module.exports = __webpack_public_path__ + "media/Components/Logos/icon-text-center-0eae5684b5f30aae3d7d388730d5fa6d.svg";